import * as React from "react";
import {useEffect, useState} from "react";
import {useAppContext} from "../hooks/useAppContext";

interface IProps {
    children: React.ReactNode;
}

export const Theme: React.FC<IProps> = ({children}) => {
    const {catalogId} = useAppContext();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        switch (catalogId) {
            case 1:
                import(
                    /* webpackMode: "eager" */
                    "../styles/d2g_variables.scss"
                    )
                    .then(() => setLoading(false));
                break;
            case 2:
                import(
                    /* webpackMode: "eager" */
                    "../styles/pu_variables.scss"
                    )
                    .then(() => setLoading(false));
                break;
            default:
                import(
                    /* webpackMode: "eager" */
                    "../styles/default_variables.scss"
                    )
                    .then(() => setLoading(false));
                break;
        }

    }, [catalogId])

    return <>{!loading && children}</>
};

